/**
 * Composable-обёртка над productSchemaStore.
 *
 * Использование в любом компоненте:
 *
 *   import { useProductSchema } from '@/composables/useProductSchema'
 *   const { fields, filterable, exportable, ready, fieldByKey } = useProductSchema()
 *
 * При первом вызове в сессии триггерит загрузку `/products/schema`.
 */
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useProductSchemaStore } from '@/stores/productSchemaStore'

export function useProductSchema() {
  const store = useProductSchemaStore()
  // fire-and-forget — store сам кэширует и дедуплицирует concurrent calls
  store.ensureLoaded()

  const { nativeFields, customFields, loaded } = storeToRefs(store)

  return {
    // raw arrays
    native: nativeFields,
    custom: customFields,
    fields: computed(() => [...nativeFields.value, ...customFields.value]),

    // готовые срезы для UI
    filterable: computed(() =>
      [...nativeFields.value, ...customFields.value].filter((f) => f.is_filterable),
    ),
    sortable: computed(() =>
      [...nativeFields.value, ...customFields.value].filter((f) => f.is_sortable),
    ),
    // Поле exportable приходит с бэка (is_exportable=True). Custom-колонки
    // экспортируются по умолчанию.
    exportable: computed(() =>
      [...nativeFields.value, ...customFields.value].filter(
        (f) => f.is_exportable !== false && f.key !== 'custom_fields',
      ),
    ),
    fieldsByGroup: computed(() => store.fieldsByGroup),

    // utility
    fieldByKey: store.fieldByKey,
    ready: loaded,
    reload: () => store.ensureLoaded(true),
    invalidate: () => store.invalidate(),
  }
}
